import React from 'react';
import PropTypes from 'prop-types';
import s from './ImageTextList.module.scss';
import ImageText from '../ImageText/ImageText';
import classNames from 'classnames';

const ImageTextList = ({
    items = [],
    isColumn = false,
    size = 'Large',
    isSquare = false,
    hideIfZero = false,
    textNoIcon = '',
}) => {
    const classes = classNames(s.Root, { [s['Root--Column']]: isColumn });

    return (
        <div className={classes}>
            <ul className={s.List}>
                {items.map((item, index) => {
                    if (item.description.startsWith('0') && hideIfZero) {
                        return null;
                    }

                    return (
                        <li key={index} className={s.Item}>
                            <ImageText
                                size={size}
                                isSquare={isSquare}
                                textNoIcon={textNoIcon}
                                {...item}
                                hideIfZero={hideIfZero}
                            />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

ImageTextList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
                isSquare: PropTypes.bool,
            }),
            description: PropTypes.string,
            isSquare: PropTypes.bool,
        })
    ),
    isColumn: PropTypes.bool,
    size: PropTypes.oneOf(['Small', 'Large']),
};

export default ImageTextList;
